export const lOGIN_ROUTE = '/login';
export const DASHBOARD_ROUTE = '/dashboard';
export const ACCOUNT_MANAGEMENT_ROUTE = '/account-management';
export const CREATE_USER_ROUTE = '/account-management/create-user';
export const CUSTOMER_ACCOUNT_REACTIVATION_ROUTE = '/customer-reactivation';
export const CUSTOMER_ACCOUNT_MANAGEMENT_ROUTE = '/customer-account-management';
export const INVENTORY_ROUTE = '/inventory';
export const INVENTORY_CATEGORY_SUBCAT_ROUTE = '/inventory/:category/:subcategory';
export const CUSTOMER_APP_ROUTE = '/product';
export const FLASHDEALS_ROUTE = `${CUSTOMER_APP_ROUTE}/flashdeals`;
export const FLASHDEALS_REORDER_ROUTE = `${FLASHDEALS_ROUTE}/reordersequence`;
export const SECTION_REORDER_ROUTE = `${CUSTOMER_APP_ROUTE}/:sectionSlug/reordersequence`;
export const DELIVERY_SLOT_ROUTE = '/delivery-timeslot';
export const ORDERS_ROUTE = '/orders';
export const SALES_ROUTE = '/sales';
export const USERS_ROUTE = '/users';
export const SETTING_ROUTE = '/checkout-settings';
export const CUSTOMER_SETTINGS_ROUTE = '/customer-settings';
export const HOMESCREEN_BANNER_ROUTE = '/homescreen-banner';
export const CREATE_HOMESCREEN_BANNER_ROUTE = '/homescreen-banner/create';
export const EDIT_HOMESCREEN_BANNER_ROUTE = '/homescreen-banner/edit';
export const ETA_STATUS_ROUTE = '/eta-status';
export const OS_NOTIFICATION_ROUTE = '/onesignalnotification';
export const PRODUCT_SYNC_ROUTE = '/product/sync';
export const ROLE_ACCESS_AND_PERMISSIONS_ROUTE = '/role-access-and-permissions';
export const ROLE_ACCESS_ROUTE = '/role-access-and-permissions/roles';
export const PERMISSIONS_ROUTE = '/role-access-and-permissions/permissions';
export const LOGISTICS_ORDER_DETAILS = '/logistics-order-details';
export const PAGE_NOT_FOUND_ROUTE = '/page-not-found';
export const NAVIGATION_ROUTE = '/navigation';
export const CREATE_NAVIGATION_ROUTE = '/navigation/create';
export const EDIT_NAVIGATION_ROUTE = '/navigation/edit/:id';
export const CREATE_SUB_NAVIGATION_ROUTE = '/navigation/create-sub';
export const EDIT_SUB_NAVIGATION_ROUTE = '/navigation/edit-sub/:id';
export const CHANGE_PASSWORD_ROUTE = '/change-password';
export const CUSTOMER_REFUND_REQUEST_ROUTE = '/customer-refund-requests';
export const AUDIT_LOG_ROUTE = '/audit-log';
export const ORDER_ERRORS_ROUTE = '/order-errors';
export const ORDER_RERUNS_ROUTE = '/order-reruns';
export const DRIVER_RATINGS_ROUTE = '/driver-ratings';
export const NAVIGATION_AUDIT_REGEX_ROUTE = '/navigation-to-auditregex';
export const SECTION_SCHEDULER_ROUTE = '/product/schedules';
export const PRODUCT_SECTION_SETTINGS_ROUTE = '/product/section-settings';
export const STOCKTAKE_ROUTE = '/stocktake';
export const STOCKTAKE_APPROVALS_ROUTE = '/stocktake-approvals';
export const CLICK_AND_COLLECT_WAREHOUSES_ROUTE = '/warehouses';
export const CLICK_AND_COLLECT_BAYS_ROUTE = '/bays';
export const CLICK_AND_COLLECT_COLLECTION_POINTS_ROUTE = '/collection-points';
export const CLICK_AND_COLLECT_GATE_CHECKIN_ROUTE = '/gate-checkin';
export const DELIVERY_TYPES_ROUTE = '/delivery-types';
export const OTP_PROVIDERS_ROUTE = '/otp-providers';
export const CLICK_AND_COLLECT_CNC_DASHBOARD_ROUTE = '/cnc-dashboard';
export const CLICK_AND_COLLECT_CNC_BOARD_ROUTE = '/cnc-board';
// A separate path rather than a flag: the two render under different layouts, and a layout is
// chosen by the route tree.
export const CLICK_AND_COLLECT_CNC_BOARD_TV_ROUTE = '/cnc-board/tv';
export const ANALYTICS_FRESH_PRODUCE_ROUTE = '/analytics/fresh-produce';
// generic report page: any registered analytics view by name — future reports need
// only a Navigation record pointing at /analytics/report/<view>, no code
export const ANALYTICS_REPORT_ROUTE = '/analytics/report/:view';
export const FAST_MOVING_SKU_ROUTE = '/fast-moving-sku';
export const ORDERS_TO_PICK_ROUTE = '/orders-to-pick';
export const PACKED_ORDERS_ROUTE = '/packed-orders';
export const PRODUCT_STOCK_SUBSCRIPTIONS_ROUTE = '/product/stock-subscriptions';
export const ANALYTICS_DISPATCH_BOARD_ROUTE = '/analytics/dispatch-board';
// The wall display. A separate path rather than a flag on the one above, because the two
// render under DIFFERENT layouts — this one outside the sidebar entirely — and a layout is
// chosen by the route tree, not by a prop.
export const ANALYTICS_DISPATCH_BOARD_TV_ROUTE = '/analytics/dispatch-board/tv';
export const RETURN_RECEPTION_ROUTE = '/return-reception';
